import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectTransportsContainerDomain = state => state.transportsContainerReducer || initialState;

export const selectRouterDomain = state => state.router || {};

export const getTransportsListSelector = () =>
	createSelector(selectTransportsContainerDomain, selectRouterDomain, ({ transportsList }) =>
		transportsList?.map(transport => ({
			...transport,
			id: transport.id,
			company: transport.company?.name,
			name: transport.name,
			number: transport.number,
			is_accredited: (() => {
				if (transport.is_accredited) return 'Да';
				if (transport.is_accredited === false) return 'Нет';
				return '-';
			})(),
		})),
	);

export const getIsTransportsListLoadingSelector = () =>
	createSelector(selectTransportsContainerDomain, ({ isTransportsListLoading }) => isTransportsListLoading);

export const getPaginationSelector = () =>
	createSelector(selectTransportsContainerDomain, ({ pagination }) => {
		if (!pagination || pagination.total === 0) {
			return null;
		}

		return {
			currentPage: pagination.current_page,
			totalPages: pagination.last_page,
			perPage: pagination.per_page,
			total: pagination.total,
			from: pagination.current_page * pagination.per_page - (pagination.per_page - 1),
			to:
				pagination.current_page === pagination.last_page
					? pagination.total
					: pagination.current_page * pagination.per_page,
			isNextItem: true,
			isPrevItem: true,
			isLastItem: false,
			isFirstItem: false,
		};
	});

export const getTableSearchSelector = () =>
	createSelector(selectTransportsContainerDomain, ({ tableSearch }) => tableSearch);

export const getFiltersSelector = () =>
	createSelector(selectTransportsContainerDomain, selectRouterDomain, ({ filters }) => filters);

export const getIsFiltersLoadingSelector = () =>
	createSelector(selectTransportsContainerDomain, ({ isFiltersLoading }) => isFiltersLoading);
